<template>
  <q-list>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I accept these
          <a :href="plan_doc_link(selected_plan, 'tos')" target="_blank" class="cp-non-link"> Terms and Conditions </a>
          and agree to transfer electricity service to {{ plan_brand(selected_plan) }}. I authorize
          {{ plan_brand(selected_plan) }} to perform the necessary tasks required to complete a switch or move
          in for new electricity service.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_2" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I verify that I am authorized to switch service at the above premises. I understand a move-in or a switch can
          only be made by the electric service applicant or the applicant's authorized agent.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_3" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I understand this is a paperless product. I agree to receive my bills and contract-related notices by email
          including contracts, disclosures, contract expiration notices and disconnect notices. I agree that I have
          provided {{ plan_brand(selected_plan) }} with a valid email address and that I will not receive my bills via regular postal
          mail.
        </q-item-label>
      </q-item-section>
    </q-item>

  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";
import { watch, ref } from "vue";

export default {
  name: "NextEraAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { selected_plan } = SelectedPlan();
    const { plan_brand, plan_doc_link } = Utilities();
    const authorizations = ref([]);

    watch(authorizations, () => {
      const agreed = authorizations.value.length === 3
      emit('update:modelValue', agreed);
    })

    return {
      authorizations,
      selected_plan,

      plan_brand,
      plan_doc_link
    }
  }
}
</script>

<style scoped>

</style>
